import React, { memo } from 'react';

import { makeStyles } from '@mui/styles';
import Box from '@mui/material/Box';
import SvgIcon from '@mui/material/SvgIcon';

const useStyles = makeStyles({
  box: {
    display: 'flex',
    alignItems: 'center',
  },
  label: {
    marginTop: '0.125rem',
    marginLeft: '0.3rem',
    height: '1rem',
    width: 'auto',
  },
});

const Quantum = () => {
  const styles = useStyles();

  return (
    <Box className={styles.box}>
      <SvgIcon viewBox="0 0 95 16" className={styles.label}>
        <path
          d="M6.85458 0.279993C10.3925 0.279993 13.0327 2.92827 13.0327 6.47696C13.0327 8.5928 12.0606 10.3938 10.508 11.4715L9.2989 10.2107C10.4876 9.43619 11.2198 8.08134 11.2198 6.47696C11.2198 3.91696 9.4068 2.02786 6.85458 2.02786C4.35516 2.02786 2.507 3.91696 2.507 6.47696C2.507 9.00165 4.35516 10.9084 6.85458 10.9084C7.12892 10.9084 7.39472 10.8864 7.65065 10.8439L8.86116 12.2679L8.9086 12.2525L8.86116 12.2679C9.66763 12.942 10.6345 13.97 12.0985 14.062L12.3111 14.0687C13.0679 14.0687 13.7896 13.9451 14.1768 13.7862L14.388 15.3045C13.9304 15.4634 13.1031 15.64 12.1878 15.64C9.3364 15.64 7.68185 13.027 6.83698 12.6386C3.35188 12.621 0.711647 9.99034 0.711647 6.47696C0.711647 2.92827 3.35188 0.279993 6.85458 0.279993ZM17.4584 0.456547V7.37737C17.4584 9.5313 18.5496 10.9437 20.8907 10.9437C23.2669 10.9437 24.3758 9.42537 24.3758 7.35972V0.456547H26.2063V7.50096C26.2063 10.2728 24.3934 12.6563 20.8907 12.6563C17.4232 12.6563 15.6278 10.5023 15.6278 7.50096V0.456547H17.4584ZM34.865 0.487247L39.6187 12.4928H37.77L36.7137 9.84449L33.7911 2.32339L30.7276 9.84449L29.636 12.4928H27.7874L32.7347 0.487247H34.865ZM43.5943 12.4621V3.3873L51.1982 12.4621H52.7999V0.456547H50.9694V9.56661L43.3655 0.456547H41.7638V12.4621H43.5943ZM61.2739 12.4621V2.08082H65.3575V0.456547H55.1486V2.08082H59.4434V12.4621H61.2739ZM72.793 12.6563C76.2957 12.6563 78.1086 10.2728 78.1086 7.50096V0.456547H76.2781V7.35972C76.2781 9.42537 75.1692 10.9437 72.793 10.9437C70.452 10.9437 69.3607 9.5313 69.3607 7.37737V0.456547H67.5301V7.50096C67.5301 10.5023 69.3255 12.6563 72.793 12.6563ZM83.3263 12.4621V3.36965L87.8323 8.84275H88.202L92.7256 3.36965V12.4621H94.5561V0.456547H92.884L88.0259 6.33572L83.1503 0.456547H81.4958V12.4621H83.3263Z"
          fill="white"
        />
      </SvgIcon>
    </Box>
  );
};

export default memo(Quantum);
